import Reviews from '@/Controller/Reviews';

window.app = new Reviews;